import React, { useState } from 'react';
import ButtonList from '../../../../../../components/ButtonList';
import DateRangePicker from '../../../../../../components/datePicker/DateRangePicker';
import BaseForm from '../../../../../../components/form/BaseForm';
import Select from '../../../../../../components/input/Select/Select';
import SearchBox from '../../../../../../components/outline/SearchBox';
import { USER_RANK_SORT_OPTION_LIST } from '../../../../../../constants/service/app/accountUserRankConstants';
import { USER_RANK_SEARCH_PERIOD_BUTTON_LIST } from '../../../../../../constants/service/app/userConstants';
import { DATE_FORMAT, QUICK_DATE_SELECT_BUTTON_TARGET } from '../../../../../../constants/service/common/utilConstants';
import { setQuickToDate } from '../../../../../../lib/common';
import moment from '../../../../../../lib/moment';
import { ACCOUNT_USER_RANK_FILTER_OPTION_MODEL } from '../../../../../../store/modules/account/user/models';
import { LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import styles from './RankSearchBox.module.scss';

const RankSearchBox = ({ getList }) => {
  const today = moment().format(DATE_FORMAT.YMD_DASH_FORMAT);
  const conditionOptions = USER_RANK_SORT_OPTION_LIST;

  const initialQuickDateState = {
    quickDateIndex: 0,
    period: {
      startDate: today,
      endDate: today,
    },
  };
  const [quickDateState, setQuickDateState] = useState(initialQuickDateState);
  const [condition, setCondition] = useState(conditionOptions.length > 0 ? conditionOptions[0].id : null);

  const handleChangeCondition = (v) => {
    setCondition(v);
  };

  const resetSearchBox = () => {
    setQuickDateState(initialQuickDateState);
    setCondition(conditionOptions.length > 0 ? conditionOptions[0].id : null);
  };

  return (
    <SearchBox
      onSearch={() => {
        getList({
          searchOption: {
            createDate: quickDateState.period,
          },
          filterOption: {
            ...ACCOUNT_USER_RANK_FILTER_OPTION_MODEL,
          },
          sortOption: [
            {
              id: condition,
              desc: true,
            },
          ],
          pagination: LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        resetSearchBox();
      }}
    >
      <BaseForm
        className="category-search"
        label="기간(주문일 기준)"
        content={
          <div className={styles.rankSearchRangeContainer}>
            {/*날짜 선택 빠른 키*/}
            <ButtonList
              current={quickDateState.quickDateIndex}
              list={USER_RANK_SEARCH_PERIOD_BUTTON_LIST}
              onClick={(data) => {
                setQuickDateState(
                  setQuickToDate({
                    id: data.id,
                    value: data.value,
                    target: QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE,
                  }),
                );
              }}
            />

            {/*날짜 선택*/}
            <DateRangePicker
              value={quickDateState.period}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(period) => {
                setQuickDateState(
                  setQuickToDate({
                    period,
                  }),
                );
              }}
            />
          </div>
        }
      />

      <BaseForm
        className="category-search"
        label="정렬기준"
        content={<Select list={conditionOptions} onChange={handleChangeCondition} value={condition} />}
      />
    </SearchBox>
  );
};

export default RankSearchBox;
